// components/PasswordReset.js
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify'; // Import toast from react-toastify
import 'react-toastify/dist/ReactToastify.css'; // Import toast CSS
const apiBase = process.env.REACT_APP_API;


const PasswordReset = () => {
  const [password, setPassword] = useState("");
  const [confirm_password, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleResetPassword = async () => {
    if (password !== confirm_password) {
      setError("Passwords do not match");
      return;
    }

    try {
      const token = localStorage.getItem("RP_token");
      await axios.post(
        `${apiBase}/reset-password/reset-password`,
        { 
            password , confirm_password 
         },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      toast.success("Password reset successfully");
      localStorage.removeItem("RP_token");
      navigate("/login");
    } catch (error) {
      setError(error.response?.data?.message || "Password reset failed");
    }
  };

  return (
    <div className="bg-white p-6 rounded shadow-lg w-80">
      <h2 className="text-2xl font-bold mb-4">Reset Your Password</h2>
      <input
        type="password"
        placeholder="New Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="w-full p-2 border border-gray-300 rounded mb-4"
      />
      <input
        type="password"
        placeholder="Confirm Password"
        value={confirm_password}
        onChange={(e) => setConfirmPassword(e.target.value)}
        className="w-full p-2 border border-gray-300 rounded mb-4"
      />
      <button
        onClick={handleResetPassword}
        className="w-full bg-purple-500 text-white p-2 rounded hover:bg-purple-600"
      >
        Reset Password
      </button>
      {error && <p className="text-red-500 mt-2">{error}</p>}
    </div>
  );
};

export default PasswordReset;
